import MenuMainModule from './menu-main'

const MenusModule = angular.module('cdbl.menus', [
  MenuMainModule
])
  .name

export default MenusModule
